import styled from 'styled-components';

import { Text, Button } from '@gympass/yoga';

export const TableContainer = styled.ul`
  width: 100% !important;
  padding-bottom: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const TableItem = styled.table`
  height: 100%;
  width: 100%;
  padding: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  :nth-child(odd) {
    background-color: ${({ theme }) => theme.yoga.colors.elements.disabledRow};
  }
`;

export const TableItemTitle = styled(Text.Small)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${({ theme }) => theme.yoga.colors.primary};
`;

export const TableItemType = styled(Text.Tiny)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  color: ${({ theme }) => theme.yoga.colors.inputDisabled};
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const TopicIcon = styled.img`
  width: ${({ theme }) => theme.yoga.spacing.small}px;
  height: auto;
  margin-right: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const TableItemAction = styled.td`
  height: 100%;
  width: 100px;
`;

export const TableItemStatus = styled.td<{
  isFinished: boolean;
}>`
  width: 200px;
  color: ${({ isFinished, theme }) =>
    isFinished ? theme.yoga.colors.success : 'black'};
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ isFinished, theme }) =>
    isFinished
      ? theme.yoga.fontWeights.medium
      : theme.yoga.fontWeights.regular};
`;

export const ViewButton = styled(Button.Link)<{
  isView: boolean;
}>`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  color: ${({ isView, theme }) =>
    isView ? theme.yoga.colors.primary : theme.yoga.colors.textDisabled};

  :disabled {
    color: ${({ theme }) => theme.yoga.colors.textDisabled};
  }
`;

export const TableItemDesc = styled.div``;
